import { Component, ContentChild, DestroyRef, inject, Input, OnInit, TemplateRef } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ObjectPath } from '@bo-client/shared/types/ObjectPath.type';
import { NBPConfig } from '@bo-client/shared/config.model';
import { combineLatestWith, debounceTime, map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tenant-config-proxy',
  templateUrl: './tenant-config-proxy.component.html',
  styleUrl: './tenant-config-proxy.component.scss'
})
export class TenantConfigProxyComponent implements OnInit {
  @Input() configPath!: ObjectPath<NBPConfig>;
  @Input() redirectOnDeactivated: boolean = false;
  @Input() redirectPath: string = '/';

  @ContentChild('proxyContent', { read: TemplateRef })
  readonly proxyContent?: TemplateRef<unknown>;

  configActive$: Observable<boolean> = of(null);
  private dataShareService = inject(DataShareService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  ngOnInit(): void {
    this.configActive$ = this.dataShareService.getSingleTenantConfig$<unknown>(this.configPath).pipe(
      takeUntilDestroyed(this.destroyRef),
      combineLatestWith(this.dataShareService.currentTenant$),
      // Wartet kurz, falls es vom TSG Mandanten zum richtigen Mandanten wechselt, um mehrere Trigger vom Observable zu verhindern.
      // Falls es tatsächlich der TSG Mandant ist, triggert das Observable trotzdem nach 100ms
      switchMap(([config, tenant]) =>
        tenant.id === 'tsg' ? of(config).pipe(debounceTime(100)) : of(config)
      ),
      map((config) => !!config),
      shareReplay(1)
    );
    /* Der Code soll erst mal nicht benutzt werden, da es Probleme mit der Navigation gibt.
    if (this.redirectOnDeactivated) {
      this.configActive$.subscribe((value) => {
        if (value === false) {
          this.toRedirect();
        }
      });
    }
    */
  }

  toRedirect() {
    this.router.navigate([this.redirectPath]).then();
  }
}
